import { z } from 'zod'
import type { DefaultValues } from 'react-hook-form'

export const createInvoiceSchema = z.object({
	rentalId:    z.string().min(1, 'finances.createDialog.errors.required'),
	type:        z.enum(['RENT', 'DEPOSIT', 'UTILITIES', 'PENALTY', 'ADDITIONAL', 'ONE_TIME']),
	amount:      z.coerce
		.number({ invalid_type_error: 'finances.createDialog.errors.amount' })
		.positive('finances.createDialog.errors.amount'),
	periodStart: z.string().min(1, 'finances.createDialog.errors.required'),
	periodEnd:   z.string().min(1, 'finances.createDialog.errors.required'),
	dueDate:     z.string().min(1, 'finances.createDialog.errors.required'),
	comment:     z.string().trim().optional(),
})

export type CreateInvoiceFormValues = z.infer<typeof createInvoiceSchema>

export const DEFAULT_VALUES: DefaultValues<CreateInvoiceFormValues> = {
	rentalId:    '',
	type:        'RENT',
	amount:      undefined,
	periodStart: '',
	periodEnd:   '',
	dueDate:     '',
	comment:     '',
}
